"use client";

import Link from "next/link";
import Layouts from "@/src/components/layouts";

export default function NotFound() {
  return (
    <Layouts>
      <div className="l-error">
        <div className="container">
          <div className="l-error__wrapper">
            <p className="l-error__number">404</p>
            <p className="l-error__title">Page introuvable</p>
            <p className="l-error__content">
              Cette page n’existe pas ou n’existe plus. <br />
              Nous vous prions de nous excuser pour la gêne occasionnée.
            </p>
            <Link href="/">
              <button className="l-error__link m-button m-button--blue">
                Retour à l&apos;accueil
              </button>
            </Link>
          </div>
        </div>
      </div>
    </Layouts>
  );
}
